import { OrderAssignment } from '../../00_modules/disposition/models';

export class AddAssignments {
    static readonly type = '[Assignment] Add Assignments';

    constructor(public orderAssignments: OrderAssignment[]) {}
}
export class DeleteAssignments {
    static readonly type = '[Assignment] Delete Assignments';

    constructor(public orderAssignmentIds: string[]) {}
}

export class UpdateAssignments {
    static readonly type = '[Assignment] Update Assignments';

    constructor(public orderAssignments: OrderAssignment[]) {}
}

export class ToggleSurveyorSelection {
    static readonly type = '[Assignment] Toggle Surveyor Selection';

    constructor(
        public businessPartnerId: number,
        public teamId: number,
        public surveyorId: number,
        public isSelected: boolean
    ) {}
}

export class ResetAssignments {
    static readonly type = '[Assignment] Reset Assignments';
}
